import { ConfirmDialog } from './ConfirmDialog';

interface UnsavedChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
  title: string;
  description: string;
  discardLabel: string;
  continueLabel: string;
}

export function UnsavedChangesDialog({
  open,
  onOpenChange,
  onDiscard,
  title,
  description,
  discardLabel,
  continueLabel,
}: UnsavedChangesDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      confirmLabel={discardLabel}
      cancelLabel={continueLabel}
      onConfirm={onDiscard}
      variant="destructive"
    />
  );
}
